import { lazy } from 'react';
import { Outlet, RouteObject } from 'react-router-dom';

const ComplianceDashboard = lazy(
  () => import('../components/Dashboard/ComplianceDashboard'),
);
const BreachManagementPage = lazy(
  () => import('../components/Breaches/BreachManagementPage'),
);
const CompliancePage = lazy(() => import('../components/Documents/DocumentsPage'));
const IntegrationPage = lazy(
  () => import('../components/Integration/IntegrationPage'),
);
const ReportsPage = lazy(() => import('../components/Reports/ReportsPage'));

const dpdpComplianceRoute: RouteObject = {
  path: '/dpdp-compliance',
  element: <Outlet />,
  children: [
    { index: true, element: <ComplianceDashboard /> },
    { path: 'breach-management', element: <BreachManagementPage /> },
    { path: 'compliance', element: <CompliancePage /> },
    { path: 'integration', element: <IntegrationPage /> },
    { path: 'reports', element: <ReportsPage /> },
  ],
};

export default dpdpComplianceRoute;
